import Chip from '@jobseeker/lotus/elements/Chip';
import {Image} from '@jobseeker/lotus/components/Image';
import {Users as DiversityIcon} from '@jobseeker/lotus/icons';
import {useState} from 'react';
import {useIsLargeDevice} from '@jobseeker/lotus/hooks';
import BottomSheet from '@jobseeker/lotus/elements/BottomSheet';
import {Box, Typography} from '@mui/material';
import Tooltip from '@jobseeker/lotus/elements/Tooltip';
export interface Tag {
  label: string;
  icon: React.ReactElement;
}

export default (props: {tags: Tag[]}) => {
  const tags: Tag[] | string = props.tags;
  const IsLarge = useIsLargeDevice();
  const [popUpOpen, setBottomSheet] = useState(false);
  const toggleBottomSheet = (event?: any) => {
    // alert('test');
    event?.stopPropagation();
    setBottomSheet(!popUpOpen);
  };
  if (!tags || !tags.length) return undefined;
  if (typeof tags === 'string') {
    return (
      <Chip
        label={tags}
        icon={
          <Image
            src={DiversityIcon}
            alt={tags}
            width={16}
            height={16}
            style={{margin: '0 2px'}}
            objectFit="cover"
            quality={50}
          />
        }
      />
    );
  } else if (tags?.length === 1)
    return <>{tags?.map(tag => <Chip {...tag} />)}</>;
  else {
    const MainChipComponent = (
      <Chip
        label={'Diversity Inclusive'}
        sx={{maxWidth: 'max-content'}}
        onClick={!IsLarge ? toggleBottomSheet : undefined}
        icon={
          <Image
            src={DiversityIcon}
            alt={'Diversity Inclusive'}
            width={16}
            height={16}
            objectFit="cover"
            quality={50}
            style={{margin: '0 2px'}}
          />
        }
      />
    );
    return (
      <>
        {IsLarge ? (
          <Tooltip
            title={<ul>{tags?.map(tag => <li>{tag.label}</li>)}</ul>}
            arrow
          >
            <Box>
              <Chip
                label={'Diversity Inclusive'}
                sx={{maxWidth: 'max-content'}}
                onClick={!IsLarge ? toggleBottomSheet : undefined}
                icon={
                  <Image
                    src={DiversityIcon}
                    alt={'Diversity Inclusive'}
                    width={16}
                    height={16}
                    objectFit="cover"
                    quality={50}
                    style={{margin: '0 2px'}}
                  />
                }
              />
            </Box>
          </Tooltip>
        ) : (
          <>
            {MainChipComponent}
            <BottomSheet
              title={`Diversity Inclusive`}
              open={popUpOpen}
              onDismiss={toggleBottomSheet}
              snapPoints={() => [300]}
            >
              <Box p={3} pt={2}>
                {tags?.map(tag => (
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '8px',
                      alignItems: 'center',
                      mb: 1,
                      color: 'text.primary',
                    }}
                  >
                    {tag.icon}
                    <Typography variant="body2">{tag.label}</Typography>
                  </Box>
                ))}
              </Box>
            </BottomSheet>
          </>
        )}
      </>
    );
  }
};
